import { Semester } from '@/store/master/types';

export interface FiscalYearSemester {
  fiscalYear: number|null,
  semester: Semester|null,
}

// 曜日
export enum Weekdays {
  mon = 'Mon',
  tue = 'Tue',
  wed = 'Wed',
  thu = 'Thu',
  fri = 'Fri',
  sat = 'Sat',
  sun = 'Sun',
}
export type weekdayKey = keyof typeof Weekdays

// 時限
export const Periods = [1, 2, 3, 4, 5, 6, 7] as const
export type periodType = typeof Periods[number]

// 権限
export enum Authorities {
  senior = 'Senior',
  tutor = 'Tutor',
  admin = 'Admin',
  partTimeJob = 'Part-time job',
}
export type authorityCode = keyof typeof Authorities

// 性別
export const Genders = {
  0: 'Male',
  1: 'Female',
  2: 'Other',
}
export type genderCode = keyof typeof Genders
